// Build information, automatically generated by `ng-info`
const build = {
    version: "1.07.00",
    timestamp: "Tue Dec 02 2025 08:39:15 GMT-0600 (Central Standard Time)",
    message: null,
    git: {
        user: null,
        branch: "develop",
        hash: "452882",
        fullHash: "4528822790efe0f7a00f51e4d83bb2e68cbefa58"
    }
};

export default build;